import React, { useState, useEffect } from 'react';
import { Button, Typography, Box } from '@mui/material';

const LinkedInLoginBtn = ({ handleResponse }) => {
    const [error, setError] = useState(null);
    const linkedinClientId = "86eszcyyfg4gqq"; //process.env.REACT_APP_LINKEDIN_CLIENT_ID;
    const redirectUri = `${window.location.origin}/linkedin-callback`;

    const handleLinkedInLogin = () => {
        if (!linkedinClientId) {
            setError('LinkedIn Client ID not configured. Please add REACT_APP_LINKEDIN_CLIENT_ID to environment variables.');
            return;
        }

        // LinkedIn OAuth 2.0 authorization URL
        const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${linkedinClientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=openid%20profile%20email`;
        window.location.href = authUrl;
    };

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Button
                    variant="outlined"
                    fullWidth
                    onClick={handleLinkedInLogin}
                    sx={{
                        textTransform: 'none',
                        fontSize: '14px',
                        padding: '10px',
                        border: '1px solid #0A66C2',
                        color: '#fff',
                        backgroundColor: '#0A66C2',
                        fontWeight: '600',
                        '&:hover': {
                            backgroundColor: '#095195',
                            border: '1px solid #095195',
                        },
                    }}
                >
                    Continue with LinkedIn
                </Button>
            </Box>
            {error && (
                <Typography
                    variant="body2"
                    color="error"
                    sx={{ mt: 1, textAlign: 'center' }}
                >
                    {error}
                </Typography>
            )}
        </>
    );
};

export default LinkedInLoginBtn;
